import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BreadCrumb } from 'src/app/models/BreadCrumbs';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from 'src/app/services/localstorage.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.sass']
})
export class BreadcrumbsComponent implements OnInit {

  faTimes = faTimes;

  @Input() hasCloseBtn = false;
  @Input() hasBackBtn = false;

  public breadcrumbs: BreadCrumb[];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public location: Location,
    private readonly localStorage: LocalStorageService
  ) {
    this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
  }

  ngOnInit() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      distinctUntilChanged(),
    ).subscribe(() => {
      this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
    });
  }

  buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: BreadCrumb[] = []): BreadCrumb[] {
    // If no routeConfig is avalailable we are on the root path
    const label = route.routeConfig && route.routeConfig.data ? route.routeConfig.data.breadcrumb : '';
    let path = route.routeConfig && route.routeConfig.data ? route.routeConfig.path : '';

    // If the route is dynamic route such as ':id', remove it
    const lastRoutePart = path.split('/').pop();
    const isDynamicRoute = lastRoutePart.startsWith(':');
    if (isDynamicRoute && !!route.snapshot) {
      const paramName = lastRoutePart.split(':')[1];
      path = path.replace(lastRoutePart, route.snapshot.params[paramName]);
    }

    // In the routeConfig the complete path is not available,
    // so we rebuild it each time
    const nextUrl = path ? `${url}/${path}` : url;

    const breadcrumb: BreadCrumb = {
      label,
      url: route.routeConfig && route.routeConfig.data && route.routeConfig.data.link ? route.routeConfig.data.link : nextUrl,
      stopNav: route.routeConfig && route.routeConfig.data && route.routeConfig.data.breadcrumbStopNav,
    };
    // Only adding route with non-empty label
    const newBreadcrumbs = breadcrumb.label ? [...breadcrumbs, breadcrumb] : [...breadcrumbs];
    if (route.firstChild) {
      // If we are not on our current path yet,
      // there will be more children to look after, to build our breadcumb
      return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }

  goToHome() {
    this.localStorage.removeItem('deploymentRedirection');
    this.router.navigate([environment.routes.subscription]);
  }

  redirect(url, index) {
    if (index == (this.breadcrumbs.length - 1)) return;
    this.localStorage.removeItem('deploymentRedirection');
    this.router.navigate([url]);
  }
}
